import React from "react";
import { useSelector } from "react-redux";
import { PCMS_URL } from "@root/src/variables";
import { useParams } from "react-router-dom";

const PCMSDashboard = () => {
  const { id } = useParams();
  const pcmsToken = useSelector((state) => state?.pcmsToken?.pcmsAccessToken);
  console.log("ID", id);

  //---------------------------------------- Get URL With token ----------------------------------------------------- //

  const getIframeSrc = () => {
    return id
      ? `${PCMS_URL}/create?token=${pcmsToken}&id=${id}`
      : `${PCMS_URL}/?token=${pcmsToken}`;
  };

  //---------------------------------------------- End ------------------------------------------------------------- //

  return (
    <iframe
      id="embeddedIframe"
      className=" w-screen h-[90vh] border-0"
      src={getIframeSrc()}
      title="Embedded Iframe"
    ></iframe>
  );
};

export default PCMSDashboard;
